import axios from "axios";

axios.defaults.baseURL = `${process.env.REACT_APP_BE_URL}/api`;
axios.defaults.withCredentials = true;

export const sendAnalytics = async (event) => {
  try {
    const response = await axios.post(
      "/analytics/pitch-page/write-event-data",
      {
        event,
      }
    );
    return response;
  } catch (err) {
    console.error(err);
  }
};

export const updateEventAmount = async (event) => {
  try {
    const response = await axios.post("/analytics/update-event-amount", {
      event: event,
      interval: process.env.REACT_APP_SESSION_TIME_POLLING_DELAY / 1000,
    });
    return response;
  } catch (err) {
    console.error(err);
  }
};
